<template>
  <div class="page_container">
    <div class="detail_title">
      <div class="detail_title_real">
        <img
          class="detail_title_real_back"
          src="https://image.zhihuishu.com/zhs/b2cm/base1/202307/2c3ae67ad9e94f3b8d4bd4971c418e94.png"
          alt="返回"
          @click="$router.back()"
        />
        <h3>
          {{
            `${classroomInspectionDetailInfo.campusName || ''} - ${
              classroomInspectionDetailInfo.buildingName || ''
            } - ${classroomInspectionDetailInfo.classroomName || ''}`
          }}
        </h3>
      </div>
      <div class="detail_title_sub">
        <div class="detail_title_sub_item">
          <span>授课人：</span>
          <span>{{ classroomInspectionDetailInfo.teacherName }}</span>
        </div>
        <div class="detail_title_sub_item_interval"></div>
        <div class="detail_title_sub_item">
          <span>课程名称：</span>
          <span>{{ classroomInspectionDetailInfo.liveName }}</span>
        </div>
        <div class="detail_title_sub_item_interval"></div>
        <div class="detail_title_sub_item">
          <span>当前巡视人：</span>
          <span>{{ classroomInspectionDetailInfo.currentInspectorName }}</span>
        </div>
      </div>
    </div>
    <div class="detail_body">
      <div class="detail_body_box">
        <div class="detail_body_inner">
          <div class="video-box">
            <div class="J_prismPlayer_class" id="J_prismPlayer_video_left_big" v-if="rtcType === 'artc'"></div>
            <video src="" autoplay muted id="video_left_big" v-else></video>
            <div class="play_explain_box">
              <span v-if="isFullscreen">{{ fullscreenTitle }}</span>
              <span v-else>{{ classroomCurrentPlay | playExplainBoxTitle }}</span>
              <div class="enter_full_screen_btn">
                <img
                  :src="
                    isFullscreen
                      ? require('../../../assets/img/myVideo/icon_shouqiquanping_24@2x.png')
                      : 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202309/a07b6ac3bffd435491e457f338ad9306.png'
                  "
                  :alt="isFullscreen ? '取消全屏' : '全屏'"
                  @click="handleFullscreen"
                />
              </div>
            </div>
          </div>
          <div class="detail_body_right">
            <div class="classroom_list scrollableBar">
              <template v-for="(item, index) in classroomList">
                <div
                  :class="[
                    'classroom_item',
                    item.uid === classroomCurrentPlay.uid &&
                    item.role === classroomCurrentPlay.role &&
                    item.streamId === classroomCurrentPlay.streamId
                      ? 'active'
                      : ''
                  ]"
                  v-if="item.role === ROLE.SPEAKER"
                  :key="item.id"
                  @click="handleChooseClassroom(item)"
                >
                  <div
                    class="J_prismPlayer_class"
                    :id="`J_prismPlayer_video_uid${item.uid}_role${item.role}`"
                    v-if="rtcType === 'artc'"
                  ></div>
                  <template v-else>
                    <video
                      src=""
                      autoplay
                      :id="`video_uid${item.uid}_role${item.role}`"
                      v-if="item.role === ROLE.SHARE_SCREEN"
                    ></video>
                    <video
                      src=""
                      autoplay
                      muted
                      :id="`video_uid${item.uid}_role${item.role}_index${index}`"
                      v-else
                    ></video>
                    <!-- <audio src="" autoplay controls :id="`audio_uid${item.uid}_role${item.role}`" v-if="!index"></audio> -->
                  </template>
                  <div class="play_explain_box">
                    <span class="play_explain_box_title">{{ item | playExplainBoxTitle }}</span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                  <!-- <div style="background-color: red; color: #FFF; position: absolute; top: 0; left: 0; font-size: 12px;">
                    {{ (item.currentVideoDevice[0] || { streamId: '' }).streamId }}
                  </div> -->
                </div>
              </template>
              <template v-for="item in classroomList">
                <div
                  :class="[
                    'classroom_item',
                    item.uid === classroomCurrentPlay.uid && item.role === classroomCurrentPlay.role ? 'active' : ''
                  ]"
                  v-if="item.role === ROLE.SHARE_SCREEN"
                  :key="item.id"
                  @click="handleChooseClassroom(item)"
                >
                  <div
                    class="J_prismPlayer_class"
                    :id="`J_prismPlayer_video_uid${item.uid}_role${item.role}`"
                    v-if="rtcType === 'artc'"
                  ></div>
                  <template v-else>
                    <video
                      src=""
                      autoplay
                      :id="`video_uid${item.uid}_role${item.role}`"
                      v-if="item.role === ROLE.SHARE_SCREEN"
                    ></video>
                    <video src="" autoplay muted :id="`video_uid${item.uid}_role${item.role}`" v-else></video>
                    <!-- <audio src="" autoplay controls :id="`audio_uid${item.uid}_role${item.role}`"></audio> -->
                  </template>
                  <div class="play_explain_box">
                    <span class="play_explain_box_title">{{ item | playExplainBoxTitle }}</span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                </div>
              </template>
              <template v-for="item in classroomList">
                <div
                  :class="[
                    'classroom_item',
                    item.uid === classroomCurrentPlay.uid && item.role === classroomCurrentPlay.role ? 'active' : ''
                  ]"
                  v-if="item.role === ROLE.LISTENER"
                  :key="item.id"
                  @click="handleChooseClassroom(item)"
                >
                  <div
                    class="J_prismPlayer_class"
                    :id="`J_prismPlayer_video_uid${item.uid}_role${item.role}`"
                    v-if="rtcType === 'artc'"
                  ></div>
                  <template v-else>
                    <video
                      src=""
                      autoplay
                      :id="`video_uid${item.uid}_role${item.role}`"
                      v-if="item.role === ROLE.SHARE_SCREEN"
                    ></video>
                    <video src="" autoplay muted :id="`video_uid${item.uid}_role${item.role}`" v-else></video>
                    <!-- <audio src="" autoplay controls :id="`audio_uid${item.uid}_role${item.role}`"></audio> -->
                  </template>
                  <div class="play_explain_box">
                    <span class="play_explain_box_title">{{ item | playExplainBoxTitle }}</span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                </div>
              </template>
              <template v-for="item in classroomList">
                <div
                  :class="[
                    'classroom_item',
                    item.uid === classroomCurrentPlay.uid && item.role === classroomCurrentPlay.role ? 'active' : ''
                  ]"
                  v-if="item.role === ROLE.STUDENT"
                  :key="item.id"
                  @click="handleChooseClassroom(item)"
                >
                  <div
                    class="J_prismPlayer_class"
                    :id="`J_prismPlayer_video_uid${item.uid}_role${item.role}`"
                    v-if="rtcType === 'artc'"
                  ></div>
                  <template v-else>
                    <video
                      src=""
                      autoplay
                      :id="`video_uid${item.uid}_role${item.role}`"
                      v-if="item.role === ROLE.SHARE_SCREEN"
                    ></video>
                    <video src="" autoplay muted :id="`video_uid${item.uid}_role${item.role}`" v-else></video>
                    <!-- <audio src="" autoplay controls :id="`audio_uid${item.uid}_role${item.role}`"></audio> -->
                  </template>
                  <div class="play_explain_box">
                    <span class="play_explain_box_title">{{ item | playExplainBoxTitle }}</span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <audio src="" id="audio_container"></audio>
        <play-button @operationForPlay="operationForPlay" v-if="autoPlayError" />
      </div>
    </div>
    <div class="operation_container">
      <div class="operation_container_left">
        <template v-if="operationLeftShow">
          <p class="classroom_observation" @click="handleObserve" v-if="classroomInspectionDetailInfo.liveSource === 3">
            课堂观摩
          </p>
          <p
            :class="['live_stream_control', liveStreamControlClassName]"
            @click="handleLiveStreamControl"
            v-if="classroomInspectionDetailInfo.liveSource === 3"
          >
            <img v-if="liveStreamControlFlag" :src="liveStreamControlIcon" alt="直播控制" />
            <span>{{ liveStreamControlTitle }}</span>
          </p>
          <p :class="['share_screen_control', shareScreenControlClassName]" @click="handleShareScreen">
            <img
              src="https://image.zhihuishu.com/zhs/b2cm/base1/202309/153b3c5d29ba4c24b2bc1361742cb64a.png"
              alt="共享屏幕"
            />
            <span>{{ shareScreenControlTitle }}</span>
          </p>
          <p class="restart_control" @click="restartConfirmDialogFlag = true" v-if="restartControlFlag">
            <img
              src="https://image.zhihuishu.com/zhs/b2cm/base1/202309/ac3d8f261cac4e0183c8f11efc1ff03b.png"
              alt="重启客户端"
            />
            <span>重启客户端</span>
          </p>
        </template>
      </div>
      <div class="operation_container_right">
        <div class="voice" @click="toggleVoiceMute">
          <img
            :src="
              voiceMuted
                ? 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/8887b0511f5a4d03b3cc815705e55144.png'
                : 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/18779e4d6bcf4ecc95ec27f7ccf64d62.png'
            "
            alt="音量"
          />
        </div>
        <div class="setting" @click="inspectionTourSettingDialogFlag = true">
          <img
            src="https://image.zhihuishu.com/zhs/b2cm/base1/202307/f5e2e17d692645199aebc035f4123e30.png"
            alt="设置"
          />
        </div>
      </div>
    </div>
    <!-- 巡视状态模块 -->
    <div class="inspection-status">
      <InspectionStatus :classroomDetail="classroomInspectionDetailInfo" />
    </div>
    <inspection-tour-setting
      :inspectionTourSettingDialogFlag="inspectionTourSettingDialogFlag"
      @handleInspectionTourSettingDialogClose="handleInspectionTourSettingDialogClose"
      :dialogDetailInfo="dialogDetailInfo"
      :streamMap="streamMap"
      :clientForZRTC="clientForZRTC"
      :clientSettingsInfo="clientSettingsInfo"
      @getClientSettings="getClientSettings"
      :mediaDeviceInfo="mediaDeviceInfo"
      @switchVideo="switchVideo"
      @switchAudio="switchAudio"
      :classroomInspectionDetailInfo="classroomInspectionDetailInfo"
      :rtcType="rtcType"
      ref="refInspectionTourSetting"
    />
    <classroom-observation
      :classroomObservationDialogFlag.sync="classroomObservationDialogFlag"
      :classroomObservationUrl="classroomObservationUrl"
      :cdnViewSettingInfo="cdnViewSettingInfo"
      @getCdnViewSettingInfo="getCdnViewSettingInfo"
    />
    <restart-confirm
      :restartConfirmDialogFlag.sync="restartConfirmDialogFlag"
      @handleRestartConfirm="handleRestartConfirm"
    />
  </div>
</template>

<script>
import BackupDialog from '../HistoricalReplay/comp/BackupDialog'
import InspectionStatus from '../HistoricalReplay/comp/InspectionStatus'
import { SOCKET_MSG_TYPE } from '@/consts/socketMsg'
import { ROLE } from '@/consts/user'
import { VIDEO_LEVEL } from '@/consts/camera'
import { DEVICE_ROLE } from '@/consts/camera'
import { getLiveInfo } from '@/server/api/guideStation'
import { checkRes } from '@/utils/tool'
export default {
  name: 'InspectionTourDetail',
  components: {
    'inspection-tour-setting': () => import('@/components/inspectionTourSetting'),
    BackupDialog,
    InspectionStatus,
    'microphone-icon': () => import('@/components/microphoneIcon/index.vue'),
    'play-button': () => import('@/components/playButton/index.vue'),
    'classroom-observation': () => import('@/components/classroomObservation'),
    'restart-confirm': () => import('@/components/restartConfirm')
  },
  filters: {
    playExplainBoxTitle: function (item) {
      const { role } = item
      let res = '- -'
      switch (role) {
        case ROLE.SPEAKER:
          // res =
          //   (((item.currentVideoDevice || [])[0] || {}).mediaLabel === 'classroom'
          //     ? `${item.uname}` + (item.classroomName ? '-' : '') + `${item.classroomName}`
          //     : item.uname || '') + '(主讲)'
          res = item.uname + (item.deviceName ? `-${item.deviceName}` : '') + '(主讲)'
          break
        case ROLE.LISTENER:
          res =
            (((item.currentVideoDevice || [])[0] || {}).mediaLabel === 'classroom'
              ? `${item.uname}` + (item.classroomName ? '-' : '') + `${item.classroomName}`
              : item.uname || '') + '(听课)'
          break
        case ROLE.STUDENT:
          res = item.uname
          break
        case ROLE.SHARE_SCREEN:
          res = '课件画面(主讲)'
          break
      }
      return res
    }
  },
  data() {
    return {
      classroomList: [],
      voiceMuted: false,
      inspectionTourSettingDialogFlag: false,
      clientForZRTC: null,
      listenedOnSignalMessage: false,
      socketMsg: {},
      classroomInspectionDetailInfo: {},
      preAudioStreamIdList: [],
      preVideoStreamIdList: [],
      streamMap: new Map(),
      dialogDetailInfo: {},
      clientSettingsInfo: {},
      mediaDeviceInfo: {},
      timerIdGetDeviceInfo: 0,
      timerIdGetClientSettings: 0,
      classroomCurrentPlay: {},
      mapAliplayerVideo: new Map(),
      rtcType: '',
      ROLE,
      autoPlayError: false,
      isFullscreen: false,
      fullscreenTitle: '',
      classroomObservationDialogFlag: false,
      restartConfirmDialogFlag: false,
      classroomObservationUrl: '',
      cdnViewSettingInfo: {},
      timerIdGetCdnViewSettingInfo: 0,

      userListOnMic: null,
      lastInfoDetail: null,
      speakerClassroom: {},
      speakerCardList: [],

      liveDetail: {}
    }
  },
  computed: {
    liveStreamControlFlag: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return false
      return true
    },
    liveStreamControlIcon: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return ''
      if (this.cdnViewSettingInfo.stopLive)
        return 'https://image.zhihuishu.com/zhs/b2cm/base1/202309/cf61316c8aec44e4b31ba0e224eadfb8.png'
      return 'https://image.zhihuishu.com/zhs/b2cm/base1/202309/c6873bd3d2624488a215d949b76b56b5.png'
    },
    liveStreamControlTitle: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return '未开启直播'
      if (this.cdnViewSettingInfo.stopLive) return '继续直播'
      return '暂停直播'
    },
    liveStreamControlClassName: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return 'gray'
      if (this.cdnViewSettingInfo.stopLive) return 'orange'
      return ''
    },
    shareScreenControlClassName: function () {
      const shareScreenItem = this.classroomList.find((item) => item.role === ROLE.SHARE_SCREEN)
      if (!shareScreenItem) return 'orange'
      return ''
    },
    shareScreenControlTitle: function () {
      const shareScreenItem = this.classroomList.find((item) => item.role === ROLE.SHARE_SCREEN)
      if (!shareScreenItem) return '开启共享'
      return '停止共享'
    },
    restartControlFlag: function () {
      // // 版本号低于0.4.0的都不展示重启按钮：
      // const clientVersion = this.clientSettingsInfo.clientVersion || ''
      // // const clientVersion = '0.4.0'
      // const clientVersionStr = clientVersion.split('.').join('')
      // if (!clientVersionStr) return false
      // const clientVersionNum = Number(clientVersionStr)
      // if (clientVersionNum < 40) return false
      // return true
      return false
    },
    operationLeftShow: function () {
      if (!Object.keys(this.classroomInspectionDetailInfo).length) return false
      const { role } = this.classroomInspectionDetailInfo
      if (role === ROLE.SPEAKER) return true
      if (role === ROLE.LISTENER) return false
      return false
    }
  },
  watch: {
    socketMsg: {
      handler: function (newVal) {
        this.dealSocketMsg(newVal)
      }
    }
  },
  methods: {
    setVoice() {
      if (this.rtcType === 'artc') {
        for (let item of this.mapAliplayerVideo.values()) {
          if (this.voiceMuted) {
            item.setVolume(0)
          } else {
            item.setVolume(1)
          }
        }
      } else {
        this.classroomList.forEach((item) => {
          // const domAudio = document.querySelector(`#audio_uid${item.uid}_role${item.role}`)
          // if (domAudio) {
          //   if (this.voiceMuted) {
          //     domAudio.pause()
          //   } else {
          //     domAudio.play()
          //   }
          // }
          const domAudio = document.querySelector(`#audio_container`)
          if (domAudio) {
            if (this.voiceMuted) {
              domAudio.pause()
            } else {
              domAudio.play()
            }
          }
          const domVideo = document.querySelector(`#video_uid${item.uid}_role${item.role}`)
          if (domVideo) {
            if (this.voiceMuted) {
              domVideo.muted = true
            } else {
              domVideo.muted = false
            }
          }
        })
      }
    },
    toggleVoiceMute() {
      const { voiceMuted } = this
      this.voiceMuted = !voiceMuted
      this.setVoice()
    },
    operationForPlay() {
      if (!this.voiceMuted) {
        this.setVoice()
      }
      this.classroomList.forEach((item) => {
        const domVideo = document.querySelector(`#video_uid${item.uid}_role${item.role}`)
        if (domVideo) {
          domVideo.play()
        }
      })
      this.autoPlayError = false
    },
    // 教室观摩
    handleObserve() {
      const { liveId } = this.classroomInspectionDetailInfo
      // this.classroomObservationUrl = `https://tju-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`
      this.classroomObservationUrl = `https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`
      this.classroomObservationDialogFlag = true
    },
    handleInspectionTourSettingDialogClose() {
      this.inspectionTourSettingDialogFlag = false
    },
    async getClassroomInspectionDetail() {
      try {
        const { liveId, classroomCode } = this.$route.query
        const params = {
          liveId,
          classroomCode
        }
        const result = await this.$http.classroomInspectionDetail(params)
        if (result.code !== 200) return
        this.classroomInspectionDetailInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    ZRTCInit() {
      return new Promise(async (resolve) => {
        const { liveId } = this.$route.query
        const client = ZRTC2.init(liveId)
        client.setClientRole('audience')
        client.setBaseUrl({
          // hilive: 'https://tju-hilive.zhihuishu.com',
          hilive: 'https://zhs-hilive.zhihuishu.com',
          // 'zhihuishu-livecourse-desktop': 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com'
          'zhihuishu-livecourse-desktop': 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com'
        })
        try {
          await client.joinAudienceRoom()
          console.log('joinRoom success')
          resolve(client)
        } catch (err) {
          console.log(err, 'joinRoom_err')
          return this.$message.error('抱歉，当前加入直播人数已达上限，无法加入！')
        }
      })
    },
    getSocketMessage() {
      if (!this.clientForZRTC) return
      if (this.listenedOnSignalMessage) return
      this.clientForZRTC.onSignalMessage((data) => {
        this.listenedOnSignalMessage = true
        this.socketMsg = data.response
      })
    },
    initDataList() {
      const { userListOnMic, lastInfoDetail } = this
      if (!userListOnMic || !lastInfoDetail) return
      // 主讲
      this.speakerClassroom = userListOnMic.find((i) => i.role == ROLE.SPEAKER) || {}
      this.getSpeakerCardList()
    },
    async getSpeakerCardList() {
      const { speakerClassroom, lastInfoDetail } = this
      let speakerStreamlist = []
      speakerClassroom.socketInfos.forEach((socketInfo) => {
        const streamList = lastInfoDetail[socketInfo.socketId].streamInfo.filter(
          (stream) =>
            stream.mediaType === 'video' &&
            stream.status === 'published' &&
            stream.mediaLabel !== 'r' &&
            stream.mediaLabel !== 'mix' &&
            stream.mediaLabel !== 'auto' &&
            (speakerClassroom.classroomType !== 1 ||
              (speakerClassroom.classroomType === 1 && stream.mediaLabel.includes('immerse')))
        )
        speakerStreamlist = [...speakerStreamlist, ...streamList]
      })
      const deviceNameObj = {
        'immerse-t': '主讲机位',
        'immerse-s': '学生机位'
      }
      this.speakerCardList = speakerStreamlist.map((speakerStream) => {
        const deviceInfo = speakerStream.deviceInfo || {}
        return {
          ...speakerStream,
          role: speakerClassroom.role,
          deviceName: speakerStream.mediaLabel.includes('screen') ? '共享屏幕' : deviceInfo.deviceName ? deviceInfo.deviceName : (['immerse-t', 'immerse-s'].includes(speakerStream.mediaLabel) ? deviceNameObj[speakerStream.mediaLabel] : '本机设备'),
          deviceRole: deviceInfo.roleType || speakerStream.mediaLabel,
          currentVideoDevice: [
            {
              streamId: speakerStream.streamId
            }
          ],
          currentAudioDevice: [...speakerClassroom.currentAudioDevice],
          uid: speakerClassroom.uid,
          uname: speakerClassroom.uname,
          classroomId: speakerClassroom.classroomId,
          classroomName: speakerClassroom.classroomName,
          cameraId: speakerClassroom.cameraId
        }
      })
      const classroomListRemoveSpeak = this.classroomList.filter((item) => item.role !== ROLE.SPEAKER)
      this.classroomList = [...this.speakerCardList, ...classroomListRemoveSpeak]
      const { classroomCode } = this.$route.query
      const itemByClassroomCode = this.classroomList.find((item) => item.classroomId === classroomCode)
      if (itemByClassroomCode) {
        this.dialogDetailInfo = itemByClassroomCode
        this.classroomCurrentPlay = itemByClassroomCode
      }
      this.initStream(this.classroomList)
    },
    async dealSocketMsg(message) {
      console.log(message, 'message_dealSocketMsg')
      const { type, content = {} } = message
      // if (
      //   [
      //     SOCKET_MSG_TYPE.USER_LIST_ON_MIC,
      //     SOCKET_MSG_TYPE.USER_PUBLISHED,
      //     SOCKET_MSG_TYPE.USER_UNPUBLISHED,
      //     SOCKET_MSG_TYPE.USER_UPDATE,
      //     SOCKET_MSG_TYPE.BASE_LIVE_INFO,
      //     SOCKET_MSG_TYPE.LIVE_INFO_UPDATE,
      //     SOCKET_MSG_TYPE.LAST_INFO_DETAIL,
      //     SOCKET_MSG_TYPE.LIVE_STATUS_UPDATE
      //   ].includes(type)
      // ) {
      //   console.log(message, 'message_dealSocketMsg', new Date().getTime())
      // }
      const isDialogDetailInfo = (this.dialogDetailInfo || {}).uid === (content || {}).uid
      switch (type) {
        case SOCKET_MSG_TYPE.USER_LIST_ON_MIC:
          console.log(content, 'content_USER_LIST_ON_MIC')
          this.classroomList = content || []

          this.userListOnMic = content
          this.initDataList()

          // this.initStream(this.classroomList)
          // this.dialogDetailInfo = this.classroomList.find(item => item.role === ROLE.SPEAKER) || {}
          // if (this.classroomList.length) {
          //   this.classroomCurrentPlay = this.classroomList[0]
          // }
          const { classroomCode } = this.$route.query
          const itemByClassroomCode = this.classroomList.find((item) => item.classroomId === classroomCode)
          if (itemByClassroomCode) {
            this.dialogDetailInfo = itemByClassroomCode
            this.classroomCurrentPlay = itemByClassroomCode
          }
          this.operationDOM()
          break
        case SOCKET_MSG_TYPE.OPEN_SCREEN:
          console.log(content, 'content_OPEN_SCREEN')
          {
            const screenItem = {
              ...content,
              role: ROLE.SHARE_SCREEN
            }
            const shareScreenUser = this.classroomList.find(
              (item) => item.uid === screenItem.uid && item.role !== ROLE.SHARE_SCREEN
            )
            // 兼容智慧听课（智慧听课也有共享屏幕），非主讲不展示共享图标：
            const canContinue = shareScreenUser?.role === ROLE.SPEAKER
            const masterIndex = this.classroomList.findIndex((item) => item.role == ROLE.SPEAKER)
            const findTheScreenItem = this.classroomList.find(
              (item) => item.role === screenItem.role && item.uid === screenItem.uid
            )
            if (canContinue && !findTheScreenItem) {
              this.classroomList.splice(masterIndex + 1, 0, screenItem)
              this.initStream(this.classroomList)
            }
          }
          break
        case SOCKET_MSG_TYPE.STOP_SCREEN:
          console.log(content, 'content_STOP_SCREEN')
          const shareScreenIndex = this.classroomList.findIndex(
            (item) => item.uid === content.uid && item.role == ROLE.SHARE_SCREEN
          )
          shareScreenIndex >= 0 && this.classroomList.splice(shareScreenIndex, 1)
          const isClassroomCurrentPlay =
            (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
            (this.classroomCurrentPlay || {}).role === ROLE.SHARE_SCREEN
          if (isClassroomCurrentPlay) {
            this.handleChooseClassroom(this.classroomList[0])
          }
          this.operationDOM()
          break
        case SOCKET_MSG_TYPE.USER_PUBLISHED:
          console.log(content, 'content_USER_PUBLISHED')
          switch (content.mediaType) {
            case 'screen':
              {
                const screenItem = {
                  ...content,
                  role: ROLE.SHARE_SCREEN,
                  currentVideoDevice: [
                    {
                      streamId: content.streamId
                    }
                  ]
                }
                const screenIndex = this.classroomList.findIndex((item) => item.role == ROLE.SHARE_SCREEN)
                const findTheScreenItem = this.classroomList.find(
                  (item) => item.role === screenItem.role && item.uid === screenItem.uid
                )
                if (findTheScreenItem) {
                  const newScreenItem = {
                    ...findTheScreenItem,
                    ...screenItem
                  }
                  this.classroomList.splice(screenIndex, 1, newScreenItem)
                  this.initStream(this.classroomList)
                }
              }
              // const shareScreenUser = this.classroomList.find(
              //   (item) => item.uid === screenItem.uid && item.role !== ROLE.SHARE_SCREEN
              // )
              // // 兼容智慧听课（智慧听课也有共享屏幕），非主讲不展示共享图标：
              // const canContinue = shareScreenUser?.role === ROLE.SPEAKER
              // const masterIndex = this.classroomList.findIndex((item) => item.role == ROLE.SPEAKER)
              // const findTheScreenItem = this.classroomList.find(
              //   (item) => item.role === screenItem.role && item.uid === screenItem.uid
              // )
              // if (canContinue && !findTheScreenItem) {
              //   this.classroomList.splice(masterIndex + 1, 0, screenItem)
              //   this.initStream(this.classroomList)
              // }
              break
            case 'video':
              {
                // const updateItem = this.classroomList.find((item) => item.uid === content.uid) || {}
                // const updateIndex = this.classroomList.findIndex((item) => item.uid === content.uid)
                // const newClassroom = {
                //   ...updateItem,
                //   currentVideoDevice: [
                //     { ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }
                //   ]
                // }
                // updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
                // const isClassroomCurrentPlay =
                //   (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
                //   (this.classroomCurrentPlay || {}).role === (content || {}).role
                // if (isClassroomCurrentPlay) {
                //   this.handleChooseClassroom(newClassroom)
                // }
                // if (isDialogDetailInfo) {
                //   this.dialogDetailInfo = newClassroom
                // }
                // this.initStream(this.classroomList)

                if (content.role === ROLE.SPEAKER) {
                  if (
                    content.mediaLabel !== 'r' &&
                    (this.speakerClassroom.classroomType !== 1 ||
                      (this.speakerClassroom.classroomType === 1 && content.mediaLabel.includes('immerse')))
                  ) {
                    const updateItem = this.classroomList.find((item) => item.streamId === content.streamId) || {}
                    const updateIndex = this.classroomList.findIndex((item) => item.streamId === content.streamId)
                    const newClassroom = {
                      ...updateItem,
                      currentVideoDevice: [
                        { ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }
                      ]
                    }
                    updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
                    const isClassroomCurrentPlay =
                      (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
                      (this.classroomCurrentPlay || {}).role === (content || {}).role &&
                      (this.classroomCurrentPlay || {}).streamId === (content || {}).streamId
                    if (isClassroomCurrentPlay) {
                      this.handleChooseClassroom(newClassroom)
                    }
                    if (isDialogDetailInfo) {
                      this.dialogDetailInfo = newClassroom
                    }
                    this.initStream(this.classroomList)
                  }
                } else {
                  const updateItem = this.classroomList.find((item) => item.uid === content.uid) || {}
                  const updateIndex = this.classroomList.findIndex((item) => item.uid === content.uid)
                  const newClassroom = {
                    ...updateItem,
                    currentVideoDevice: [
                      { ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }
                    ]
                  }
                  updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
                  const isClassroomCurrentPlay =
                    (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
                    (this.classroomCurrentPlay || {}).role === (content || {}).role
                  if (isClassroomCurrentPlay) {
                    this.handleChooseClassroom(newClassroom)
                  }
                  if (isDialogDetailInfo) {
                    this.dialogDetailInfo = newClassroom
                  }
                  this.initStream(this.classroomList)
                }
              }
              break
            // case 'audio':
            //   {
            //     const updateItem = this.classroomList.find((item) => item.uid === content.uid) || {}
            //     const updateIndex = this.classroomList.findIndex((item) => item.userId == content.uid)
            //     const newClassroom = {
            //       ...updateItem,
            //       currentAudioDevice: [
            //         { ...((updateItem.currentAudioDevice || [])[0] || {}), streamId: content.streamId || '' }
            //       ]
            //     }
            //     updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
            //     const isClassroomCurrentPlay =
            //       (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
            //       (this.classroomCurrentPlay || {}).role === (content || {}).role
            //     if (isClassroomCurrentPlay) {
            //       this.handleChooseClassroom(newClassroom)
            //     }
            //     this.initStream(this.classroomList)
            //   }
            //   break
          }
          break
        case SOCKET_MSG_TYPE.USER_UNPUBLISHED:
          console.log(content, 'content_USER_UNPUBLISHED')
          switch (
            content.mediaType
            // case 'screen':
            //   const shareScreenIndex = this.classroomList.findIndex(
            //     (item) => item.uid === content.uid && item.role == ROLE.SHARE_SCREEN
            //   )
            //   shareScreenIndex >= 0 && this.classroomList.splice(shareScreenIndex, 1)
            //   const isClassroomCurrentPlay =
            //     (this.classroomCurrentPlay || {}).uid === (content || {}).uid &&
            //     (this.classroomCurrentPlay || {}).role === ROLE.SHARE_SCREEN
            //   if (isClassroomCurrentPlay) {
            //     this.handleChooseClassroom(this.classroomList[0])
            //   }
            //   this.operationDOM()
            //   break
          ) {
          }
          break
        case SOCKET_MSG_TYPE.USER_UPDATE:
          console.log(content, 'content_USER_UPDATE')
          {
            const { _add, _delete } = content
            if (_add) {
              const joinUserInfo = {
                ..._add
              }
              if (_add.role === ROLE.LISTENER || _add.role === ROLE.STUDENT) {
                const findTheItem = this.classroomList.find(
                  (item) => item.role === joinUserInfo.role && item.uid === joinUserInfo.uid
                )
                if (!findTheItem) {
                  this.classroomList.push(joinUserInfo)
                  this.initStream(this.classroomList)
                }
              }
            }
            if (_delete) {
              const delIndex = this.classroomList.findIndex((i) => i.uid === _delete.uid)
              delIndex >= 0 && this.classroomList.splice(delIndex, 1)
              const isClassroomCurrentPlay = (this.classroomCurrentPlay || {}).uid === (content || {}).uid
              if (isClassroomCurrentPlay) {
                this.handleChooseClassroom(this.classroomList[0])
              }
              this.operationDOM()
            }
          }
          break
        case SOCKET_MSG_TYPE.DEVICE_LIST_ACK:
          if (Object.prototype.toString.call(content).slice(8, -1) === 'Object') {
            console.log(content, 'content_DEVICE_LIST_ACK')
            this.mediaDeviceInfo = content
          }
          break
        case SOCKET_MSG_TYPE.BASE_LIVE_INFO:
          console.log(content, 'content_BASE_LIVE_INFO')
          this.rtcType = content.rtcType
          break
        case SOCKET_MSG_TYPE.LIVE_INFO_UPDATE:
          console.log(content, 'content_LIVE_INFO_UPDATE')
          if (content._changes.includes('rtcType')) {
            this.rtcType = content.rtcType
            this.initStream(this.classroomList)
          }
          break
        case SOCKET_MSG_TYPE.LAST_INFO_DETAIL:
          console.log(content, 'content_LAST_INFO_DETAIL')
          const objReal = JSON.parse(JSON.stringify(content))
          delete objReal.autoStreamStatus
          const map = new Map()
          Object.values(objReal).forEach((item) => {
            item.streamInfo.forEach((v) => {
              if (v.mediaType === 'video' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'video', v.streamId)
              }
              if (v.mediaType === 'audio' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'audio', v.streamId)
              }
              if (
                v.mediaType === 'screen' &&
                v.status === 'published' &&
                v.mediaLabel === 'screenStream' &&
                item.openScreen
              ) {
                const contentNew = {
                  ...item,
                  role: ROLE.SHARE_SCREEN,
                  currentVideoDevice: [
                    {
                      streamId: v.streamId
                    }
                  ]
                }
                const shareScreenUser = this.classroomList.find(
                  (item) => item.uid === contentNew.uid && item.role !== ROLE.SHARE_SCREEN
                )
                // 兼容智慧听课（智慧听课也有共享屏幕），非主讲不展示共享图标：
                const canContinue = shareScreenUser?.role === ROLE.SPEAKER
                const masterIndex = this.classroomList.findIndex((v) => v.role == ROLE.SPEAKER)
                const findTheScreenItem = this.classroomList.find(
                  (item) => item.role === contentNew.role && item.uid === contentNew.uid
                )
                if (canContinue && !findTheScreenItem) {
                  this.classroomList.splice(masterIndex + 1, 0, contentNew)
                  this.initStream(this.classroomList)
                }
              }
            })
          })
          this.classroomList = this.classroomList.map((item) => {
            if (item.role == ROLE.STUDENT) {
              const newItem = {
                ...item,
                currentVideoDevice: [
                  {
                    ...((item.currentVideoDevice || [])[0] || {}),
                    streamId: map.get(item.uid + 'mediaType' + 'video') || ''
                  }
                ],
                currentAudioDevice: [
                  {
                    ...((item.currentAudioDevice || [])[0] || {}),
                    streamId: map.get(item.uid + 'mediaType' + 'audio') || ''
                  }
                ]
              }
              return newItem
            } else {
              return item
            }
          })

          this.lastInfoDetail = content
          this.initDataList()

          // this.initStream(this.classroomList)
          break
        case SOCKET_MSG_TYPE.VOLUME_INDICATOR:
          console.log(content, 'content_VOLUME_INDICATOR')
          const mapStreamIdVolume = new Map()
          const hasVoiceStreamIdList = (content || [])
            .filter((item) => {
              mapStreamIdVolume.set(item.streamId, item.volume)
              if (item.hasVoice) return item
            })
            .map((item) => item.streamId)
          this.classroomList = this.classroomList.map((item) => {
            ;(item.currentAudioDevice || []).forEach((v) => {
              if (hasVoiceStreamIdList.includes(v.streamId)) {
                item.speaking = true
                const volume = mapStreamIdVolume.get(v.streamId)
                item.barHeightForAudio = (Math.random() + 2) * volume + '%'
              } else {
                item.speaking = false
                item.barHeightForAudio = '0%'
              }
            })
            return item
          })
          break
        case SOCKET_MSG_TYPE.LIVE_STATUS_UPDATE:
          console.log(content, 'content_LIVE_STATUS_UPDATE')
          if (content.status == 2) {
            this.$router.back()
          }
          break
      }
    },
    async initStream(list) {
      if (this.rtcType === 'artc') return
      const audioStreamIdList = []
      const videoStreamIdList = []
      list.forEach((item) => {
        ;(item.currentAudioDevice || []).forEach((v) => {
          if (v.streamId) audioStreamIdList.push(v.streamId)
        })
        ;(item.currentVideoDevice || []).forEach((v) => {
          if (v.streamId) videoStreamIdList.push(v.streamId)
        })
      })
      const intersectionForAudioStreamId = audioStreamIdList.filter(
        (item) => !new Set(this.preAudioStreamIdList).has(item)
      )
      const intersectionForVideoStreamId = videoStreamIdList.filter(
        (item) => !new Set(this.preVideoStreamIdList).has(item)
      )
      this.preAudioStreamIdList = audioStreamIdList
      this.preAudioStreamIdList = videoStreamIdList
      console.log(intersectionForAudioStreamId, 'intersectionForAudioStreamId')
      console.log(intersectionForVideoStreamId, 'intersectionForVideoStreamId')
      for (let i = 0, len = intersectionForAudioStreamId.length; i < len; i++) {
        ;(async (i) => {
          try {
            console.log(intersectionForAudioStreamId[i], 'intersectionForAudioStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForAudioStreamId[i], 'audio')
            console.log(res, 'intersectionForAudioStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationDOM()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
      for (let i = 0, len = intersectionForVideoStreamId.length; i < len; i++) {
        ;(async (i) => {
          try {
            console.log(intersectionForVideoStreamId[i], 'intersectionForVideoStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForVideoStreamId[i], undefined, VIDEO_LEVEL.MID)
            console.log(res, 'intersectionForVideoStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationDOM()
            this.$refs.refInspectionTourSetting.operationDOM()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
    },
    async getClientSettings() {
      try {
        const { macAddr } = this.classroomInspectionDetailInfo
        const params = {
          macAddr
        }
        const result = await this.$http.clientSettingGet(params)
        if (result.code !== 200) return
        this.clientSettingsInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    getDeviceInfo() {
      this.sendCustomSignal('device-list', {})
    },
    switchVideo(videoDeviceSelected) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType: 'remote-control',
          to: socketId,
          content: {
            operationType: 'switch-video',
            deviceId: videoDeviceSelected
          }
        })
      }
    },
    switchAudio(audioDeviceSelected) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType: 'remote-control',
          to: socketId,
          content: {
            operationType: 'switch-audio',
            deviceId: audioDeviceSelected
          }
        })
      }
    },
    operationDOM() {
      this.$nextTick(() => {
        const { cdnRtsPullUrl } = this.classroomInspectionDetailInfo
        if (this.rtcType === 'artc') {
          // 首先处理右边的列表：
          this.classroomList.forEach((item) => {
            const domId = `J_prismPlayer_video_uid${item.uid}_role${item.role}`
            this.initAliplayerVideo(domId, cdnRtsPullUrl, true)
          })
          // 其次处理左边的：
          this.initAliplayerVideo('J_prismPlayer_video_left_big', cdnRtsPullUrl, false)
        } else {
          // 首先处理右边的列表：
          this.classroomList.forEach(async (item, index) => {
            let domVideo = document.querySelector(`#video_uid${item.uid}_role${item.role}`)
            if (item.role === ROLE.SPEAKER) {
              domVideo = document.querySelector(`#video_uid${item.uid}_role${item.role}_index${index}`)
            }
            const videoStreamId = (item.currentVideoDevice[0] || { streamId: '' }).streamId
            const videoStream = this.streamMap.get(videoStreamId)
            videoStream?.setResolutionLevel && videoStream.setResolutionLevel(VIDEO_LEVEL.MID)
            if (domVideo) {
              if (domVideo.srcObject !== videoStream) {
                domVideo.srcObject = videoStream
              }
            }
            // const domAudio = document.querySelector(`#audio_uid${item.uid}_role${item.role}`)
            // let mediaStreamAudio = new MediaStream()
            // ;(item.currentAudioDevice || []).forEach((v) => {
            //   const audioStream = this.streamMap.get(v.streamId)
            //   if (audioStream) {
            //     const tracks = audioStream.getTracks()
            //     tracks.forEach((track) => {
            //       mediaStreamAudio.addTrack(track)
            //     })
            //   }
            // })
            // if (domAudio) {
            //   domAudio.srcObject = mediaStreamAudio
            //   if (!this.voiceMuted) {
            //     try {
            //       await domAudio.play()
            //       this.autoPlayError = false
            //     } catch (err) {
            //       if (String(err).includes('first')) {
            //         this.autoPlayError = true
            //       } else {
            //         this.autoPlayError = false
            //       }
            //     }
            //   } else {
            //     domAudio.pause()
            //   }
            // }
          })
          // 其次处理左边的：
          const domVideo = document.querySelector(`#video_left_big`)
          if (Object.keys(this.classroomCurrentPlay).length) {
            const videoStreamId = (this.classroomCurrentPlay.currentVideoDevice[0] || { streamId: '' }).streamId
            const videoStream = this.streamMap.get(videoStreamId)
            videoStream?.setResolutionLevel && videoStream.setResolutionLevel(VIDEO_LEVEL.NORMAL)
            if (domVideo.srcObject !== videoStream) {
              domVideo.srcObject = videoStream
            }
          }
        }
      })
    },
    initAliplayerVideo(id, url, setMap) {
      const props = {
        id,
        width: '100%',
        height: '100%',
        autoplay: true,
        preload: true,
        controlBarVisibility: 'always',
        useH5Prism: true,
        playsinline: true,
        isLive: false,
        language: 'zh-cn',
        source: '',
        cover: '',
        components: [],
        skinLayout: []
      }
      this.$nextTick(() => {
        const playerForAliplayer = new Aliplayer(props)
        url && playerForAliplayer.loadByUrl(url)
        if (id === 'J_prismPlayer_video_left_big') playerForAliplayer.setVolume(0)
        setMap && this.mapAliplayerVideo.set(id, playerForAliplayer)
      })
    },
    handleChooseClassroom(item) {
      this.classroomCurrentPlay = item
      this.operationDOM()
    },
    async classroomInspectionGetSchoolInfo() {
      try {
        if (this.classroomCurrentPlay.classroomId) {
          const result = await this.$http.classroomInspectionGetSchoolInfo({
            classroomCode: this.classroomCurrentPlay.classroomId
          })
          if (result.code === 200) {
            this.fullscreenTitle = result.rt.schoolName || ''
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleFullscreen() {
      this.fullscreenTitle = ''
      this.classroomInspectionGetSchoolInfo()
      this.isFullscreen = !this.isFullscreen
      if (this.isFullscreen) {
        const element = document.querySelector('.video-box')
        element && this.enterFullscreen(element)
      } else {
        this.exitFullscreen()
      }
    },
    enterFullscreen(element) {
      if (element.requestFullScreen) {
        element.requestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen()
      }
    },
    exitFullscreen() {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen()
      }
    },
    async handleLiveStreamControl() {
      try {
        if (!this.cdnViewSettingInfo.pushRtmp) return
        const { liveId } = this.$route.query
        const params = {
          liveId,
          stopLive: this.cdnViewSettingInfo.stopLive ? 2 : 1
        }
        const result = await this.$http.livesettingContinueOrStopLive(params)
        if (result.code !== 200) return this.$message.error(result.msg || '抱歉，设置失败')
        this.$message.success('设置成功')
        this.getCdnViewSettingInfo()
      } catch (err) {
        console.log(err)
      }
    },
    sendCustomSignal(txType, content) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType,
          to: socketId,
          content: {
            ...content
          }
        })
      }
    },
    handleShareScreen() {
      console.log(this.shareScreenControlTitle, 'shareScreenControlTitle_shareScreenControlTitle')
      let operationType = ''
      switch (this.shareScreenControlTitle) {
        case '开启共享':
          operationType = 'start-screen-share'
          break
        case '停止共享':
          operationType = 'stop-screen-share'
          break
      }
      this.sendCustomSignal('remote-control', {
        operationType
      })
    },
    handleRestartConfirm() {
      this.sendCustomSignal('remote-control', {
        operationType: 'restart-client'
      })
    },
    async getCdnViewSettingInfo() {
      try {
        const { liveId } = this.$route.query
        const params = {
          liveId
        }
        const result = await this.$http.livesettingCdnViewSettingGet(params)
        if (result.code !== 200) return
        this.cdnViewSettingInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    async getLiveDetail() {
      const self = this
      const { liveId } = this.$route.query
      const params = {
        liveId
      }
      const res = await getLiveInfo(params)
      checkRes({
        res,
        success(data) {
          self.liveDetail = data.rt
        },
        failed() {
          self.$message.error('获取课程详情失败')
        }
      })
    },
    // 订阅mix流：
    async subscribMixStream() {
      if (!Object.keys(this.liveDetail) || !this.clientForZRTC) return
      const streamId = this.liveDetail.mixStreamId
      if (!streamId) return
      const res = await this.clientForZRTC.subscribe(streamId, 'audio')
      this.streamMap.set(res.streamId, res)
      this.$nextTick(async () => {
        const audioContainer = document.querySelector('#audio_container')
        if (audioContainer) {
          if (audioContainer.srcObject !== this.streamMap.get(streamId)) {
            audioContainer.srcObject = this.streamMap.get(streamId)
          }
        }
        try {
          await audioContainer.play()
          this.autoPlayError = false
        } catch (err) {
          if (String(err).includes('first')) {
            this.autoPlayError = true
          } else {
            this.autoPlayError = false
          }
        }
      })
    }
  },
  async created() {
    const { liveId, classroomCode } = this.$route.query
    if (!liveId || !classroomCode) return this.$router.go(-1)
    await this.getClassroomInspectionDetail()
    // 获取设置：
    this.getClientSettings()
    this.timerIdGetClientSettings = setInterval(() => {
      this.getClientSettings()
    }, 2000)
    // 获取教室观摩设置：
    this.getCdnViewSettingInfo()
    this.timerIdGetCdnViewSettingInfo = setInterval(() => {
      this.getCdnViewSettingInfo()
    }, 2000)
    if (!this.clientForZRTC) {
      this.clientForZRTC = await this.ZRTCInit()
    }
    this.getSocketMessage()
    // 后台需要获取设备：
    this.getDeviceInfo()
    this.timerIdGetDeviceInfo = setInterval(() => {
      this.getDeviceInfo()
    }, 2000)
    await this.getLiveDetail()
    // 订阅mix流：
    this.subscribMixStream()
  },
  mounted() {
    const _that = this
    window.addEventListener('resize', function () {
      if (document.fullscreenElement) {
        _that.isFullscreen = true
      } else {
        _that.isFullscreen = false
      }
    })
  },
  beforeDestroy() {
    this.clientForZRTC && this.clientForZRTC.leaveRoom()
    this.timerIdGetDeviceInfo && clearInterval(this.timerIdGetDeviceInfo)
    this.timerIdGetClientSettings && clearInterval(this.timerIdGetClientSettings)
    this.timerIdGetCdnViewSettingInfo && clearInterval(this.timerIdGetCdnViewSettingInfo)
  }
}
</script>

<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: 100%;
  padding: 16px 0 16px 16px;
  background-color: #f6f8fa;
  .inspection-status {
    padding: 16px 16px 1px;
    box-shadow: 0px 2px 6px 0px rgba(1, 22, 43, 0.08);
    background: #fff;
    // min-height: 192px;
  }
  .detail_title {
    .detail_title_real {
      display: flex;
      align-items: center;
      .detail_title_real_back {
        width: 25px;
        height: 25px;
        display: block;
        margin-right: 5px;
        cursor: pointer;
        &:hover {
          background-color: #f5f5f5;
        }
        &:active {
          background-color: #fff;
        }
      }
      h3 {
        font-size: 20px;
        font-weight: 500;
        color: #1e2228;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .detail_title_sub {
      width: 100%;
      height: 16px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #6f7c91;
      margin-top: 8px;
      .detail_title_sub_item_interval {
        width: 1px;
        height: 16px;
        background-color: #6f7c91;
        margin: 0 16px;
      }
    }
  }
  .detail_body {
    width: calc(100% - 280px);
    box-sizing: border-box;
    margin-top: 20px;
    .detail_body_box {
      width: 100%;
      height: 0;
      padding-top: calc(100% * 9 / 16);
      box-sizing: border-box;
      background-color: #222;
      position: relative;
      .detail_body_inner {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        .video-box {
          width: 100%;
          height: 100%;
          position: relative;
          &:hover {
            .play_explain_box .enter_full_screen_btn {
              display: block;
            }
          }
          .J_prismPlayer_class {
            width: 100%;
            height: 100%;
          }
          video {
            height: 100%;
            width: 100%;
            background-color: #000;
            display: block;
          }
          .play_explain_box {
            width: 100%;
            height: 56px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
            position: absolute;
            bottom: 0px;
            left: 0px;
            line-height: 56px;
            font-size: 14px;
            padding: 0 16px;
            color: #fff;
            z-index: 2;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .enter_full_screen_btn {
              width: 56px;
              height: 56px;
              position: absolute;
              right: 0;
              top: 0;
              padding: 16px;
              display: none;
              img {
                width: 24px;
                height: 24px;
                display: block;
                cursor: pointer;
              }
            }
          }
        }
        .detail_body_right {
          width: 280px;
          padding: 16px 0 0 20px;
          position: absolute;
          top: 0;
          right: -280px; //276px;
          bottom: 0;
          background: #232633;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .classroom_list {
            max-height: 100%;
            overflow-y: auto;
          }
          .classroom_item {
            border: 3px solid #232633;
            width: 246px;
            height: 141px;
            border-radius: 4px;
            overflow: hidden;
            margin-bottom: 16px;
            background-color: #222;
            position: relative;
            cursor: pointer;
            &.active {
              border: 3px solid #fb6f33;
            }
            .J_prismPlayer_class {
              width: 100%;
              height: 100%;
            }
            video {
              width: 100%;
              height: 100%;
              background-color: #000;
              display: block;
            }
            // audio {
            //   position: absolute;
            //   top: -5000px;
            //   left: -5000px;
            // }
            .play_explain_box {
              width: 100%;
              height: 28px;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
              position: absolute;
              bottom: 0px;
              left: 0px;
              line-height: 28px;
              font-size: 12px;
              padding: 0 10px;
              color: #fff;
              z-index: 2;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .play_explain_box_title {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
  .operation_container {
    width: 100%;
    height: 58px;
    margin-bottom: 16px;
    background: #2e313f;
    display: flex;
    justify-content: space-between;
    .operation_container_left {
      display: flex;
      align-items: center;
      .classroom_observation,
      .live_stream_control,
      .share_screen_control,
      .restart_control {
        background: #5f60d3;
        border-radius: 14px;
        font-size: 12px;
        font-weight: 500;
        color: #eaedf0;
        line-height: 28px;
        text-align: center;
        margin-left: 16px;
        user-select: none;
        cursor: pointer;
        height: 28px;
        &:hover {
          background: #4c4eaf;
        }
        &:active {
          background: #5f60d3;
        }
      }
      .classroom_observation {
        width: 80px;
      }
      .live_stream_control,
      .share_screen_control,
      .restart_control {
        width: 96px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.gray {
          background: #eceef3;
          color: #afb1b8;
          cursor: not-allowed;
          &:hover {
            background: #eceef3;
          }
          &:active {
            background: #eceef3;
          }
        }
        &.orange {
          background: #fb6f33;
          &:hover {
            background: #d65c27;
          }
          &:active {
            background: #fb6f33;
          }
        }
        img {
          width: 12px;
          height: 12px;
          display: block;
          margin-right: 4px;
        }
      }
    }
    .operation_container_right {
      display: flex;
      align-items: center;
      .voice,
      .setting {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        user-select: none;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
}
</style>
